module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-hress3e",
    attrs: {
      "id": "hress3e"
    }
  }, [_c('hrms15e')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3b8ad7d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hress3e/component.vue
// module id = 3697
// module chunks = 1